module.exports = __webpack_public_path__ + "static/media/criticalillness.f188941f.svg";